module.exports = __webpack_public_path__ + "static/media/napoleon-2.089b30b9.png";